import { OrderDeliveryMethods, type OrderDto } from '@/shared/api/order';

const getDeliveryAddressByMethod = (delivery: OrderDto['delivery']): string => {
    switch (delivery.method) {
        case OrderDeliveryMethods.COURIER: {
            return delivery.address.courier_address;
        }
        case OrderDeliveryMethods.PICKUP_POINT: {
            return delivery.address.pickup_point_address as string;
        }
        case OrderDeliveryMethods.SELF_PICK_UP: {
            return delivery.address.self_pick_up_address as string;
        }

        default: {
            return delivery.address.address;
        }
    }
};

export const getOrderDeliveryAddress = (order: OrderDto): string => {
    const { locality, appartment } = order.delivery.address;

    const address = getDeliveryAddressByMethod(order.delivery);

    return [
        locality,
        address,
        appartment && order.delivery.method === OrderDeliveryMethods.COURIER ? `кв. ${appartment}` : null,
    ]
        .filter(Boolean)
        .join(', ');
};
